import { render, staticRenderFns } from "./RootFooter.vue?vue&type=template&id=223cefcc&scoped=true&"
import script from "./RootFooter.vue?vue&type=script&lang=js&"
export * from "./RootFooter.vue?vue&type=script&lang=js&"
import style0 from "./RootFooter.vue?vue&type=style&index=0&id=223cefcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223cefcc",
  null
  
)

export default component.exports